<template>
  <ReviewItemDetails
    :expansion-panel="expansionPanel"
    :is-metadata-expanded="isMetadataExpanded"
    :review-item="reviewItem"
  />
  <div class="border-b border-l border-mid-neutral-50">
    <AttributeEditor
      v-if="isIncluded"
      :attribute-structure="attribute"
      :study="reviewItem"
      :is-expanded="expansionPanel.isShown.value"
      :is-review-read-only="review.isLocked.value"
      :expansion-panel="expansionPanel"
    />
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewItem } from '@core/domain/models/reviewItem.model'
import { computed } from 'vue'
import { INCLUDED } from '@core/domain/types/included-screening-criterion.type'
import { ReviewKey } from '@app/views/Review/use-review'
import useExpansionPanel from '@app/composables/use-expansion-panel'
import AttributeEditor from './AttributeEditor.vue'
import ReviewItemDetails from '@app/views/Review/Execute/ReviewItemDetails/ReviewItemDetails.vue'
import { AttributeStructure } from '@core/domain/models/data-extraction-plan-attribute'

const props = defineProps<{
  reviewItem: ReviewItem
  isMetadataExpanded: boolean
  attribute: AttributeStructure
}>()

const review = injectStrict(ReviewKey)

const expansionPanel = useExpansionPanel()

const isIncluded = computed(() => {
  return props.reviewItem.fullTextScreening === INCLUDED
})
</script>
